'use es6';
/**
 * Present when the popup is open.
 */
export const popupOpen = 'data-popup-open';

/**
 * Present when a pressable trigger is pressed.
 */
export const pressed = 'data-pressed';